import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

type PriceInfoProps = {
  price: number
  sign?: '+' | '-'
  label: string
  isBadge?: boolean
  variant?: VariantColor
  textColor?: TailwindColor
}

type PriceInfoInput = Omit<PriceInfoProps, 'variant' | 'textColor'>

type Props = {
  title?: string
  emptyMessage?: string
  pricesInfo: PriceInfoInput[] | PriceInfoInput
  variant?: VariantColor
  textColor?: TailwindColor
  display?: boolean
}

export const PriceInfo = ({
  price,
  sign,
  label,
  isBadge,
  variant = 'grey',
  textColor = tailwindColors.grey.lighter
}: PriceInfoProps) => {
  return (
    <div className="flex w-full justify-between items-center">
      {isBadge ? (
        <Badge
          text={label}
          variant={variant}
          textVariant="label-medium"
          size="small"
          textColor={textColor}
          className="h-6"
        />
      ) : (
        <Typography variant="label-medium" color={tailwindColors.grey.light.active}>
          {label}
        </Typography>
      )}
      <Typography variant="label-semibold" color={tailwindColors.black.DEFAULT}>
        {sign}
        {price} €
      </Typography>
    </div>
  )
}

const PriceLabel = ({ title, pricesInfo, emptyMessage, display = true, ...rest }: Props) => {
  if (!display) return null
  return (
    <div className="flex flex-col gap-1">
      <Typography variant="label-medium" color={tailwindColors.grey.light.active}>
        {title}
      </Typography>
      {emptyMessage && Array.isArray(pricesInfo) && pricesInfo.length === 0 && (
        <Typography variant="label-medium" color={tailwindColors.black.DEFAULT}>
          {emptyMessage}
        </Typography>
      )}
      {Array.isArray(pricesInfo) ? (
        pricesInfo.map((priceInfo, index) => <PriceInfo key={index} {...rest} {...priceInfo} />)
      ) : (
        <PriceInfo {...rest} {...pricesInfo} />
      )}
    </div>
  )
}

export default PriceLabel
